import React from 'react';

function StudentSchoolConfirm({ schoolDetails, schoolId, onConfirm, onBackHome, isLoading }) {
  if (isLoading) {
    return (
      <div className="student-card-body">
        <span className="student-section-title">SCHOOL DETAILS</span>
        <p className="student-helper-text">Loading school details for {schoolId}...</p>
      </div>
    );
  }

  if (!schoolDetails) {
    return (
      <div className="student-card-body">
        <span className="student-section-title">SCHOOL DETAILS</span>
        <p className="student-helper-text">No school details found for {schoolId}.</p>
        <button type="button" className="student-primary-button" onClick={onBackHome}>
          <span className="student-primary-button-text">GO BACK</span>
        </button>
      </div>
    );
  }

  return (
    <div className="student-card-body">
      <span className="student-section-title">CONFIRM YOUR SCHOOL</span>
      <p className="student-helper-text">Confirm that these school details are correct.</p>

      <div className="student-readonly-grid">
        <div className="student-readonly-field">
          <span className="student-field-label">SCHOOL STATE</span>
          <div className="student-readonly-value">{schoolDetails.state}</div>
        </div>
        <div className="student-readonly-field">
          <span className="student-field-label">SCHOOL DISTRICT / ZONE</span>
          <div className="student-readonly-value">{schoolDetails.district}</div>
        </div>
        <div className="student-readonly-field">
          <span className="student-field-label">SCHOOL CITY / BLOCK / WARD</span>
          <div className="student-readonly-value">{schoolDetails.city}</div>
        </div>
        <div className="student-readonly-field">
          <span className="student-field-label">SCHOOL NAME</span>
          <div className="student-readonly-value">{schoolDetails.school_name}</div>
        </div>
      </div>

      <button type="button" className="student-primary-button" onClick={onConfirm}>
        <span className="student-primary-button-text">CONFIRM SCHOOL</span>
      </button>
    </div>
  );
}

export default StudentSchoolConfirm;
